import PostesTab from "@features/creation/postes/components/PostesTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Wrench } from "lucide-react";

export const Route = createFileRoute("/_app/creation/postes/")({
  loader: requirePermission(PERMISSIONS.CREATION.POSTES.VIEW),
  staticData: {
    title: "Postes",
    icon: Wrench,
    tab_icon: Wrench,
    permission: PERMISSIONS.CREATION.POSTES.VIEW,
    module: "creation",
    section: "Creation",
    order: 25,
    description: "Gestion des postes de travail",
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: PostesTab,
});
